import React from "react";

export const ETYPE_META = {
  song_request: ["Song Request", "text-brand-cyan border-brand-cyan/40 bg-brand-cyan/10"],
  dedication: ["Dedication", "text-pink-300 border-pink-400/40 bg-pink-400/10"],
  question: ["Question", "text-sky-300 border-sky-400/40 bg-sky-400/10"],
  complaint: ["Complaint", "text-rose-300 border-rose-400/40 bg-rose-400/10"],
  compliment: ["Compliment", "text-emerald-300 border-emerald-400/40 bg-emerald-400/10"],
  contest_entry: ["Contest Entry", "text-violet-300 border-violet-400/40 bg-violet-400/10"],
  advertising_inquiry: ["Ad Inquiry", "text-brand-amber border-brand-amber/40 bg-brand-amber/10"],
  technical_support: ["Tech Support", "text-orange-300 border-orange-400/40 bg-orange-400/10"],
  general_feedback: ["Feedback", "text-ink-secondary border-line bg-bg-elevated"],
  sales_lead: ["Sales Lead", "text-brand-amber border-brand-amber/40 bg-brand-amber/10"],
};

export const STATUS_META = {
  new: ["New", "text-brand-amber border-brand-amber/40 bg-brand-amber/10"],
  pending: ["Pending", "text-brand-amber border-brand-amber/40 bg-brand-amber/10"],
  approved: ["Approved", "text-emerald-300 border-emerald-400/40 bg-emerald-400/10"],
  fulfilled: ["Fulfilled", "text-brand-cyan border-brand-cyan/40 bg-brand-cyan/10"],
  declined: ["Declined", "text-rose-300 border-rose-400/40 bg-rose-400/10"],
  scheduled: ["Scheduled", "text-sky-300 border-sky-400/40 bg-sky-400/10"],
  played: ["Played", "text-ink-muted border-line bg-bg-elevated"],
  aired: ["Aired", "text-ink-muted border-line bg-bg-elevated"],
  resolved: ["Resolved", "text-emerald-300 border-emerald-400/40 bg-emerald-400/10"],
  archived: ["Archived", "text-ink-muted border-line bg-bg-elevated"],
  rejected: ["Declined", "text-rose-300 border-rose-400/40 bg-rose-400/10"],
  flagged: ["Flagged", "text-rose-300 border-rose-400/40 bg-rose-400/10"],
};

export const Badge = ({ meta, testid }) => {
  const [label, cls] = meta || ["—", "text-ink-muted border-line"];
  return (
    <span data-testid={testid}
      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-mono uppercase tracking-wide ${cls}`}>
      {label}
    </span>
  );
};

export const timeAgo = (iso) => {
  if (!iso) return "";
  const s = Math.floor((Date.now() - new Date(iso).getTime()) / 1000);
  if (s < 60) return "just now";
  if (s < 3600) return `${Math.floor(s / 60)}m ago`;
  if (s < 86400) return `${Math.floor(s / 3600)}h ago`;
  return `${Math.floor(s / 86400)}d ago`;
};

export const KpiCard = ({ label, value, accent, testid }) => (
  <div className="rounded-xl border border-line bg-bg-surface p-4" data-testid={testid}>
    <div className={`font-display text-2xl font-bold ${accent || ""}`}>{value}</div>
    <div className="font-mono text-[10px] uppercase tracking-wider text-ink-muted mt-1">{label}</div>
  </div>
);

export const FilterTabs = ({ tabs, active, onChange, counts }) => (
  <div className="flex flex-wrap gap-1.5">
    {tabs.map(([key, label]) => (
      <button key={key} onClick={() => onChange(key)} data-testid={`eng-filter-${key}`}
        className={`rounded-full px-3 py-1.5 text-xs font-bold border transition ${
          active === key ? "bg-brand-amber text-black border-brand-amber"
                         : "border-line text-ink-secondary hover:text-ink-primary"}`}>
        {label}{counts && counts[key] != null ? ` (${counts[key]})` : ""}
      </button>
    ))}
  </div>
);
